import { styled, Tooltip } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import InfoIcon from '@material-ui/icons/Info';
import { colors, div, Flex } from 'lqx-react';
import * as React from 'react';
import { CompanyModel, PlatformCompany } from 'api';
import SettingsOutlined from '@material-ui/icons/Settings';
import ThumbUpAltOutlined from '@material-ui/icons/ThumbUp';
import { withStyles } from "@material-ui/core";

export const CustomerSupplier = ({ customer, supplier, payorAgent }:{
    customer? : PlatformCompany,
    supplier? : PlatformCompany,
    payorAgent? : PlatformCompany,
}) => {
    
    return (
        <Flex row alignCenter>
            <RowH3Bold>{supplier && supplier.name}</RowH3Bold>
            { payorAgent ? 
                <>
                    <Circles/>
                    <RowH3Bold>{payorAgent && payorAgent.name}</RowH3Bold>
                </> : undefined
            }
            <Circles/>
            <RowH3Bold>{customer && customer.name}</RowH3Bold>
        </Flex>
    )
}

export const Circles = 
    styled(
        ({ className }) =>
            <div className={ className + ' root' }>
                <div className="circle"></div>
                <div className="circle right"></div>
            </div>
    )({
        '&.root' : {
            display: 'flex',
            marginLeft: 8, 
            marginRight: 8, 
        },

        '& .right' : {
            marginLeft: -6
        },

        '& .circle' : {
            boxSizing: 'border-box',
            height: 12,
            width: 12,
            border: '1px solid #C0CAD0',
            borderRadius: 6
        }
    })


export const RowH1 = div({
    color: ( props : any ) => props.error ? colors.red : '#000',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: 500
})

export const RowH2 = div({
    color: ( props : any ) => props.error ? colors.red : '#000',
    fontFamily: 'Montserrat',
    fontSize: 14,
})

export const RowH2Bold = div({
    color: ( props : any ) => props.error ? colors.red : '#000',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: 600,
})

const StyledHelpIcon = ({bgColor = 'white'}) => {
    return (
        <div style={{width:'17px'}}>
            <span
                style={{
                    display: "flex",
                    justifyContent: "Center",
                    alignItems: "Center",
                    position: 'relative',
                    height:'21px'
                }}
            >
                <StyledSettingOutline backgroundColor={bgColor}/>
                <ThumbUpAltOutlined aria-label='Help Icon' style={{color: '#007bff', fontSize: 15}}/>
            </span>
        </div>
    );
};

export const StyledSettingOutline = withStyles(()=>({
    root: {
        fontSize: 9,
        color: '#007bff',
        cursor: 'pointer',
        position: 'absolute',
        zIndex: 1,
        top: 10,
        right: 11,
        borderRadius: 11,
        background: (props: any) => props.backgroundColor ? props.backgroundColor : 'white',
    }
}))(SettingsOutlined);

export const MatchLabelIcon = styled(
    ({ type, bgColor = 'white', ...props }) =>
        <Tooltip title={
            type === 'remittance_advice' ? 'Matched via Remittance Advice.' :
            type === 'remittance_info' ? 'Matched via Payment Info. Invoice numbers appearing in payment info are selected' :
            type === 'heuristic' || type === 'greedy' ? `Matched with heuristic. Invoices best fitting the remaining payment's amount are selected` :
                'Manually matched'
        }>
            <div {...props}>
                {
                    type === 'remittance_advice' ? <RemittanceAdviceIcon /> :
                    type === 'remittance_info' ? <PaymentInfoIcon /> :
                    type === 'heuristic' || type === 'greedy' ? <StyledHelpIcon bgColor={bgColor}/> :
                        '🅜'
                }
            </div>
        </Tooltip>    
)({
    fontSize: 14,
    color: ( props : any ) =>
        props.type === 'remittance_advice' || props.type === 'remittance_info' ?
            colors.green :
            colors.yellow,
    cursor: 'pointer'
})

export const RemittanceAdviceIcon = ({ invalid } : {
    invalid? : boolean
}) => {
    return <DescriptionIcon style={{ color : invalid ? colors.red : colors.green }}/>
}

export const PaymentInfoIcon = ({ invalid } : {
    invalid? : boolean
}) => {
    return <InfoIcon style={{ color : invalid ? colors.red : colors.green }} />
}

interface IChipStyle {
    color?: string,
    textColor?: string,
    border?: boolean
}

export const MatchLabel = ({ type, count, onClick = () => undefined, chipStyle = { color: 'white' }, unfundedInvoiceCount = undefined, label = undefined } : {
    type : string,
    count? : number,
    onClick? : () => void,
    chipStyle?: IChipStyle,
    unfundedInvoiceCount?: number,
    label?: string 
}) => {
    return count || label ?
        <Chip color={chipStyle.color} textColor={chipStyle.textColor} border={chipStyle.border}>
            <MatchLabelIcon type={ type } bgColor={chipStyle.color}/>
            {count ? <Counter>{count} { unfundedInvoiceCount ? `(${unfundedInvoiceCount} Unfunded Inv)` : undefined }</Counter> : null }
            {label ? <Counter>{label}</Counter> : null }
        </Chip>
    :
        <MatchLabelIcon type={ type } onClick={onClick} bgColor={chipStyle.color}/>
}

const Counter = div({
    padding : "0 4px 0 4px"
});

const getColor = (color: string) => {
    if(colors[color]){
        return colors[color]
    }
    return color;
}

export const Chip = div({
    minWidth: 43,
    margin: '0px 2px 0px 2px',
    display: 'flex',
    /* padding: 0px 5px 0px 0px; */
    alignItems: 'center',
    padding: "0 4px 0 4px",
    fontWeight: 600,
    borderRadius: 12,
    opacity: '1!important',
    backgroundColor: ( props : any ) => props.color ? getColor(props.color) : '#656565',
    border: ( props : any ) => props.border ? "1px solid black" : '',
    color: ( props : any ) => props.textColor ? getColor(props.textColor) : 'white',
})

export const SmallChip = div({
    color: 'black',
    margin: '0px 4px 0px 4px',
    display: 'flex',
    /* padding: 0px 5px 0px 0px; */
    alignItems: 'center',
    padding: "0 4px 0 4px",
    fontWeight: 400,
    fontSize: 10,
    borderRadius: 12,
    opacity: '1!important',
    borderColor: '#656565',
    borderWidth: 1,
    borderStyle: 'solid'
})

export const RowH3 = div({
    color: '#617580',
    fontFamily: 'Montserrat',
    fontSize: 13,
})

export const RowH3Bold = div({
    opacity: 0.75,
    color: '#052C4C',
    fontFamily: 'Montserrat',
    fontSize: 13,
    fontWeight: 500,
})

export const RowH4 = div({
    color: '#000',
    fontFamily: 'Montserrat',
    fontSize: 12,
})